import React from 'react';

export const PriceTooltipAccordionIcon = (props: any) => {
  const {showTooltipInfo, setShowTooltipInfo, color} = props;
  const accordionIconRotation = showTooltipInfo ? '270' : '90';
  const accordionIconTranslate = showTooltipInfo ? '8' : '7';

  return (
    <div
      onClick={() => {
        setShowTooltipInfo(!showTooltipInfo);
      }}>
      <svg width="16px" height="16px" viewBox="0 0 16 16" id="estimated-price">
        <g
          id="33--Rede-Medica_App"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd">
          <g
            id="MY-A-33-02-07_SemRatingTooltipPreco"
            transform="translate(-339.000000, -187.000000)">
            <rect fill="none" x="0" y="0" width="375" height="1317"></rect>
            <g
              id="group-3"
              transform="translate(0.000000, 55.000000)"
              fill="none">
              <path
                d="M0,10.057377 C60.497817,3.35245902 122.329368,0 185.494652,0 C248.659937,0 311.828386,3.35245902 375,10.057377 L375,612.5 L0,612.5 L0,10.057377 Z"
                id="rectangle"></path>
            </g>
            <g id="group-2" transform="translate(20.000000, 182.000000)">
              <g
                id="preco-estimado"
                transform="translate(247.000000, 0.000000)">
                <g
                  id="group-10"
                  transform="translate(80.000000, 13.000000) scale(1, -1) translate(-80.000000, -13.000000) translate(72.000000, 5.000000)">
                  <path
                    d="M5.18153548,5.66283507 L8.33788543,8.48894881 L5.14939683,11.3438386 C5.06940072,11.4154292 5.01877183,11.5137545 5.00714663,11.6200452 C4.97296282,11.9325919 5.06141022,12.2204289 5.27248883,12.4835562 C5.47642021,12.7377739 5.74406744,12.9056612 6.07543053,12.9872182 C6.21476912,13.0214851 6.36218784,12.9858985 6.4700957,12.8919223 L10.6147075,9.28240604 C11.1027447,8.89664005 11.1271465,8.17811683 10.6879131,7.75907511 L6.49547848,4.10808104 C6.37782684,4.00561047 6.21406807,3.97317156 6.0658037,4.0229613 C5.6826125,4.15164353 5.41817421,4.3067892 5.27248883,4.48839833 C5.12339402,4.6742576 5.04484045,4.95494332 5.03682812,5.33045548 C5.03416219,5.45684917 5.08696574,5.57815978 5.18153548,5.66283507 Z"
                    id="estimated-price"
                    fill={color}
                    transform={`translate(8.000000, 8.500000) rotate(-${accordionIconRotation}.000000) translate(-${accordionIconTranslate}.000000, -8.500000) `}></path>
                  <circle
                    id="Oval"
                    stroke={color}
                    strokeWidth="1.5"
                    cx="8"
                    cy="8"
                    r="7.25"></circle>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
